<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card
          color="#EBF0FF"
          outlined
          class="rounded-lg"
          style="border-left: 8px solid #2661ff !important;"
        >
          <v-card-title
            class="subtitle-1 font-weight-medium"
            style="color: #2661FF;"
          >
            <v-icon color="#2661FF" class="px-4 mb-1">
              warning
            </v-icon>
            <span>{{ $t("organization_billing.plan_resume.title") }}</span>
          </v-card-title>
          <v-card-text v-if="organizationPlan.plan_id">
            <InfoRow
              label="Nombre"
              :value="organizationPlan.plan.display_name"
            />
            <InfoRow
              v-if="
                ![getPlanIdByName('no_plan')].includes(organizationPlan.plan_id)
              "
              label="Divisa"
              :value="organizationPlan.currency.name"
            />
            <InfoRow
              v-if="
                ![
                  getPlanIdByName('no_plan'),
                  getPlanIdByName('variable_license_COP'),
                  getPlanIdByName('variable_license_USD')
                ].includes(organizationPlan.plan_id)
              "
              label="Monto"
              :value="
                organizationPlan.amount
                  | valueFormatCurrency(organizationPlan.currency.symbol)
              "
            />
            <InfoRow
              v-if="
                [
                  getPlanIdByName('variable_license_COP'),
                  getPlanIdByName('variable_license_USD')
                ].includes(organizationPlan.plan_id)
              "
              label="Monto"
              value="Monto variable"
            />
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title
            v-if="organizationPlan.plan_automation_id"
            class="subtitle-1 font-weight-medium"
            style="color: #2661FF;"
          >
            <v-icon color="#2661FF" class="px-4 mb-1">
              warning
            </v-icon>
            <span>{{
              $t("organization_billing.automation_resume.title")
            }}</span>
          </v-card-title>
          <v-card-text v-if="organizationPlan.plan_automation_id">
            <InfoRow
              label="Nombre"
              :value="organizationPlan.plan_automation.display_name"
            />
            <InfoRow
              v-if="
                ![getPlanIdByName('no_plan')].includes(organizationPlan.plan_id)
              "
              label="Costo por email"
              :value="
                `${organizationPlan.currency.symbol}
            ${organizationPlan.plan_automation.email_cost}
            (${organizationPlan.currency.code})`
              "
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import InfoRow from "@/components/Organization/Details/InfoRow";
import plansMixin from "@/mixins/plans";

export default {
  name: "PlanResume",
  mixins: [plansMixin],
  components: { InfoRow },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      organizationPlan: ({ organization: { organizationPlan } }) =>
        organizationPlan
    })
  }
};
</script>

<style lang="scss" scoped></style>
